import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const createReferrerList = createAsyncThunk(
  "referrerList/createReferrerList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/referrerList/createReferrerList",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const updateReferrerList = createAsyncThunk(
  "referrerList/updateReferrerList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "/referrerList/updateReferrerList",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const getAllReferrerList = createAsyncThunk(
  "referrerList/getAllReferrerList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/referrerList/getAllReferrerList",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const deleteReferrerList = createAsyncThunk(
  "referrerList/deleteReferrerList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/referrerList/deleteReferrerList",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const initialState = {
  loading: false,
  referrerList: [],
  currentPage: 1,
  totalPages: 1,
  totalCount: 0,
  limit: 9,
  searchMessage: null,
  createReferrerListSuccessMessage: null,
  createReferrerListErrorMessage: null,
  updateReferrerListSuccessMessage: null,
  updateReferrerListErrorMessage: null,
  deleteReferrerListSuccessMessage: null,
  deleteReferrerListErrorMessage: null,
};
const referalAmountSlice = createSlice({
  name: "referrerList",
  initialState,
  reducers: {
    resetReferrerListCreateMessage: (state) => {
      state.createReferrerListSuccessMessage = null;
      state.createReferrerListErrorMessage = null;
    },
    resetReferrerListUpdateMessage: (state) => {
      state.updateReferrerListSuccessMessage = null;
      state.updateReferrerListErrorMessage = null;
    },
    resetReferrerListDeleteMessage: (state) => {
      state.deleteReferrerListSuccessMessage = null;
      state.deleteReferrerListErrorMessage = null;
    },

    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageLimit: (state, action) => {
      state.limit = action.payload;
      state.currentPage = 1;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createReferrerList.pending, (state) => {
        state.loading = true;
        state.createReferrerListSuccessMessage = null;
        state.createReferrerListErrorMessage = null;
      })
      .addCase(createReferrerList.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.createReferrerListErrorMessage =
            action.payload.result?.message;
        } else {
          state.createReferrerListSuccessMessage =
            action.payload.result?.message;
        }
      })
      .addCase(createReferrerList.rejected, (state, action) => {
        state.loading = false;
        state.createReferrerListErrorMessage = action.payload;
      })
      .addCase(updateReferrerList.pending, (state) => {
        state.loading = true;
        state.updateReferrerListSuccessMessage = null;
        state.updateReferrerListErrorMessage = null;
      })
      .addCase(updateReferrerList.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.updateReferrerListErrorMessage =
            action.payload.result?.message;
        } else {
          state.updateReferrerListSuccessMessage =
            action.payload.result?.message;
        }
      })
      .addCase(updateReferrerList.rejected, (state, action) => {
        state.loading = false;
        state.updateReferrerListErrorMessage = action.payload;
      })
      .addCase(getAllReferrerList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllReferrerList.fulfilled, (state, action) => {
        state.loading = false;

        if (action.payload.success === false) {
          state.referrerList = [];
          state.totalCount = 0;
          state.totalPages = 1;
          state.searchMessage = action.payload.message;
          return;
        }

        state.referrerList = action.payload.list || [];
        state.currentPage = action.payload.currentPage || 1;
        state.totalPages = action.payload.totalPages || 1;
        state.totalCount = action.payload.totalCount || 0;
        state.limit = action.payload.limit || 9;
        state.searchMessage = null;
      })
      .addCase(getAllReferrerList.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteReferrerList.pending, (state) => {
        state.loading = true;
        state.deleteReferrerListSuccessMessage = null;
        state.deleteReferrerListErrorMessage = null;
      })
      .addCase(deleteReferrerList.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.deleteReferrerListErrorMessage =
            action.payload.result?.message;
        } else {
          state.deleteReferrerListSuccessMessage =
            action.payload.result?.message;
        }
      })
      .addCase(deleteReferrerList.rejected, (state, action) => {
        state.loading = false;
        state.deleteReferrerListErrorMessage = action.payload;
      });
  },
});

export const {
  resetReferrerListCreateMessage,
  resetReferrerListUpdateMessage,
  resetReferrerListDeleteMessage,
  setCurrentPage,
  setPageLimit,
} = referalAmountSlice.actions;

export default referalAmountSlice.reducer;
